import { Col, Row } from 'antd';
import React from 'react'
import '../../assets/css/factor.css';

export const FactorComponent = ({
    setLoading,
    showMessage,
    reserve
}) => {
    // ====================================================================== 
    // گروه‌بندی غذاها بر اساس نام و جمع‌بندی تعداد و بیشترین قیمت
    const groupedFoods = reserve.foods.reduce((acc, food) => {
        const key = food.foodTitle;
        if (!acc[key]) {
            acc[key] = { ...food, total: (food.price || 0) * food.count };
        } else {
            acc[key].count += food.count;
            // انتخاب بیشترین قیمت
            acc[key].price = Math.max(acc[key].price || 0, food.price || 0);
            acc[key].total = acc[key].count * acc[key].price;
        }
        return acc;
    }, {});

    // تبدیل آبجکت گروه‌بندی شده به آرایه و فیلتر غذاهایی که total > 0 دارند
    const foodsWithTotal = Object.values(groupedFoods).filter(food => {
        const totalValue = typeof food.total === 'number' ? food.total : 
                          (typeof food.total === 'string' ? parseFloat(food.total) || 0 : 0);
        return totalValue > 0;
    });

    // محاسبه هزینه پارکینگ
    let parkingTotal = 0;
    if (reserve.parking)
        parkingTotal = reserve.parking?.count * reserve.parking.price * reserve.factor.nightCount;

    // ایجاد ردیف پارکینگ (همیشه نمایش داده می‌شود)
    const parkingItem = {
        id: 'parking',
        foodTitle: 'پارکینگ',
        count: `${reserve.parking ? reserve.parking.count : 0} * ${reserve.factor.nightCount}`,
        price: `${reserve.parking ? reserve.parking.price : 0}`,
        total: parkingTotal,
    };

    // اضافه کردن ردیف پارکینگ به لیست
    const invoiceItems = [
        ...foodsWithTotal,
        parkingItem // پارکینگ همیشه اضافه می‌شود
    ];

    // محاسبه جمع کل فاکتور (شامل غذاها و پارکینگ)
    const totalInvoice = invoiceItems.reduce((sum, item) => {
        const itemTotal = typeof item.total === 'number' ? item.total : 
                         (typeof item.total === 'string' ? parseFloat(item.total) || 0 : 0);
        return sum + itemTotal;
    }, 0);

    // ====================================================================== 

    return (
        <div className='container factor'>
            <Row className="titleRow">
                <Col xs={12} sm={5} md={6} lg={2} xl={2} className="titleColumn">
                    ردیف
                </Col>
                <Col xs={0} sm={4} md={0} lg={7} xl={7} className="titleColumn">
                    نام آیتم
                </Col>
                <Col xs={0} sm={4} md={5} lg={4} xl={4} className="titleColumn">
                    تعداد
                </Col>
                <Col xs={0} sm={5} md={6} lg={5} xl={5} className="titleColumn">
                    فی (ریال)
                </Col>
                <Col xs={12} sm={6} md={7} lg={6} xl={6} className="titleColumn">
                    جمع (ریال)
                </Col>
            </Row>

            {/* نمایش غذاها */}
            {foodsWithTotal.map((item, index) => (
                <Row className="valueRow" key={item.id || item.foodTitle || index}>
                    <Col xs={12} sm={5} md={6} lg={2} xl={2} className="valueTitle">
                        {index + 1}
                    </Col>
                    <Col xs={0} sm={4} md={0} lg={7} xl={7} className="valueTitle">
                        {item.foodTitle}
                    </Col>
                    <Col xs={0} sm={4} md={5} lg={4} xl={4} className="valueColumn">
                        {item.count}
                    </Col>
                    <Col xs={0} sm={5} md={6} lg={5} xl={5} className="valueColumn">
                        {typeof item.price === 'number' ? 
                         item.price.toLocaleString() : 
                         (item.price || '0')}
                    </Col>
                    <Col xs={12} sm={6} md={7} lg={6} xl={6} className="valueColumn">
                        {typeof item.total === 'number' ? 
                         item.total.toLocaleString() : 
                         (parseFloat(item.total) || 0).toLocaleString()}
                    </Col>
                </Row>
            ))}

            {/* نمایش پارکینگ (همیشه) */}
            <Row className="valueRow" key="parking">
                <Col xs={12} sm={5} md={6} lg={2} xl={2} className="valueTitle">
                    {foodsWithTotal.length + 1}
                </Col>
                <Col xs={0} sm={4} md={0} lg={7} xl={7} className="valueTitle">
                    {parkingItem.foodTitle}
                </Col>
                <Col xs={0} sm={4} md={5} lg={4} xl={4} className="valueColumn">
                    {parkingItem.count}
                </Col>
                <Col xs={0} sm={5} md={6} lg={5} xl={5} className="valueColumn">
                    {parkingItem.price ? parkingItem.price.toLocaleString() : '0'}
                </Col>
                <Col xs={12} sm={6} md={7} lg={6} xl={6} className="valueColumn">
                    {parkingItem.total.toLocaleString()}
                </Col>
            </Row>

            {/* اگر هیچ غذایی و پارکینگی وجود نداشت */}
            {foodsWithTotal.length === 0 && parkingTotal === 0 && (
                <Row className="valueRow">
                    <Col span={24} className="valueColumn" style={{ textAlign: 'center', padding: '20px' }}>
                        هیچ آیتمی برای نمایش وجود ندارد
                    </Col>
                </Row>
            )}

            <Row className="valueRow">
                <Col xs={12} sm={5} md={6} lg={2} xl={2} className="valueTitle">
                </Col>
                <Col xs={0} sm={4} md={0} lg={7} xl={7} className="valueTitle">
                    جمع کل فاکتور:
                </Col>
                <Col xs={0} sm={4} md={5} lg={4} xl={4} className="valueColumn">
                </Col>
                <Col xs={0} sm={5} md={6} lg={5} xl={5} className="valueColumn">
                </Col>
                <Col xs={12} sm={6} md={7} lg={6} xl={6} className="valueTitle">
                    {totalInvoice.toLocaleString()} ریال
                </Col>
            </Row>
        </div>
    )
}